module.exports = __webpack_public_path__ + "static/media/skip-forward-w64.29a97017.svg";